/**
 * @generated SignedSource<<d818579aa74706a66a530a5a8ae478e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameProjectStageInput = {
  id: string;
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RenameProjectStageMutation$variables = {
  input: RenameProjectStageInput;
};
export type RenameProjectStageMutation$data = {
  readonly renameProjectStage: {
    readonly projectStage: {
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
};
export type RenameProjectStageMutation = {
  variables: RenameProjectStageMutation$variables;
  response: RenameProjectStageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenameProjectStagePayload",
    "kind": "LinkedField",
    "name": "renameProjectStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomProjectStage",
        "kind": "LinkedField",
        "name": "projectStage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenameProjectStageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenameProjectStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e507041fe2a988429ab3449a81b5b5e",
    "id": null,
    "metadata": {},
    "name": "RenameProjectStageMutation",
    "operationKind": "mutation",
    "text": "mutation RenameProjectStageMutation(\n  $input: RenameProjectStageInput!\n) {\n  renameProjectStage(input: $input) {\n    projectStage {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59664d4d962cd709a2bc4898dcb198d6";

export default node;
